<template>
  <div class="bg-con">
    <div class="content">
      <img src="@/assets/infoPublic/images/img_icon.png"
           alt="">
      <p class="success">操作成功</p>
      <p class="record">可去发布任务记录查看发布详情</p>
    </div>
    <div class="content">
      <van-button size="small"
                  type="primary"
                  class="ok-btn"
                  round
                  @click.native='GoIndexPage'>确定</van-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "OperationSuccessful",
  data () {
    return {

    };
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  methods: {
    GoIndexPage: function () {
      this.$router.push('/home/ClassCardInfoSend');
    }
  }
};
</script>
<style lang="less" scoped>
.bg-con {
  background: #fff;
  padding: 35% 0;
}
.content {
  width: 100%;
  margin: 0 auto 215px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content > img {
  width: 356px;
}

.success {
  font-size: 30px;
  font-weight: normal;
  color: rgba(17, 17, 17, 1);
  margin: 35px 0 25px;
}

.record {
  font-size: 28px;
  font-weight: normal;
  color: #4878e3;
}
.ok-btn {
  background: @blue;
  text-align: center;
  width: 37% !important;
  height: 64px;
  margin: 0 auto;
  color: #fff;
  border: none;
  font-size: 30px;
}
</style>